import { render } from "./ChatApp.vue?vue&type=template&id=de77e45e&scoped=true"
import script from "./ChatApp.vue?vue&type=script&lang=js"
export * from "./ChatApp.vue?vue&type=script&lang=js"

import "./ChatApp.vue?vue&type=style&index=0&id=de77e45e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de77e45e"]])

export default __exports__